import {StyleParamType, createStylesParams} from '@wix/tpa-settings'

import {Alignment, Direction, ImageSize} from '../../../../../../types/createStylesParams'

export type HeaderLayoutStylesParams = {
  breadcrumbsAlignment: StyleParamType.Number
  titleAndSubtitleAlignment: StyleParamType.Number
  detailsBoxAlignment: StyleParamType.Number
  detailsBoxCellStretch: StyleParamType.Number
  detailsBoxTextAlignment: StyleParamType.Number
  headerButtonAlignment: StyleParamType.Number
  imageAlignment: StyleParamType.Number
  imageSize: StyleParamType.Number
}

export const headerLayoutStylesParams = createStylesParams<HeaderLayoutStylesParams>({
  breadcrumbsAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Left,
  },
  titleAndSubtitleAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Center,
  },
  detailsBoxAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Stretch,
  },
  detailsBoxCellStretch: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  detailsBoxTextAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Center,
  },
  headerButtonAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Center,
  },
  imageAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Direction.Normal,
  },
  imageSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => ImageSize.Crop,
  },
})
